import {
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonImg,
} from "@ionic/react";
import React, { useEffect } from "react";
import {
  IonList,
  IonItem,
  IonLabel,
  IonInput
} from "@ionic/react";
import { capitalize } from "../../../utils/helper";
import { CallNumber } from "@ionic-native/call-number";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import { Anywhere } from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { formatStatesList } from "../../../pages/Manage/ManageCapacity/ManagaCapacityUtil";
import "./ManageCapacityViewPage.scss";
import { ManageCapacityHeader } from "../../../web/components/manage-capacity/ManageCapacityHeader";
import renderRawDate, { dateWithCurrentTimezone } from "../../../utils/CapacityDate";

export const ManageCapacityPage: React.FC<any> = (props: any) => {
  const {
    selectedCapacity: item,
    isNetworkAvailable,
    showNetworkAlert,
    history,
    userDetails,
  } = props;

  useEffect(() => {
    setScreenName("screen_manage_capacity_view");
    logEvent(EVENT.SV_MANAGE_CAPACITY_ADDEDIT, {
      screen: SCREEN.MANAGE_CAPACITY_ADDEDIT,
      carrierId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
    });
    if (props.countryStateCodes && props.countryStateCodes.length === 0) {
      props.getCountryStateCodes();
    }
  }, []);

  const onEditClick = () => {
    if (isNetworkAvailable) {
      history.push(`/app/manage-capacity/edit/${item.capacityId}`, {
        showPage: true,
      });
    } else {
      showNetworkAlert();
    }
  };

  const pickupDateType =
    item.capacityType === "TRUCK"
      ? [
        {
          title: "Pick-up Start Date",
          slug: "pickup-start-date",
          value: item && renderRawDate(item.pickUpFromDate, true, false),
        },
        {
          title: "Pick-up End Date",
          slug: "pickup-end-date",
          value: item && renderRawDate(item.pickUpToDate, true, false),
        },
      ]
      : [
        {
          title: "Days of Week",
          slug: "days-of-week",
          value:
            (item &&
              item.preferredDays &&
              item.preferredDays
                .map((value: string) => capitalize(value.substr(0, 3), true))
                .join(", ")) ||
            "",
        },
      ];

  const radius =
    !item.destinationStates ||
      (item.destinationStates &&
        item.destinationStates.length === 0 &&
        item.destination.radius)
      ? [
        {
          title: "Destination Radius",
          slug: "destination-radius",
          value: item.destination.radius
            ? `${item.destination.radius}mi`
            : "NA",
        },
      ]
      : [];

  let destinationValue;
  if(item?.destinationStates?.length > 0){
    destinationValue = formatStatesList(item.destinationStates).join(", ");
  } else if (item.destination.city !== null){
    const statePart = item.destination.state ? `, ${item.destination.state}` : '';
    destinationValue = `${item.destination.city}${statePart}`;
  } else {
    destinationValue = 'Anywhere';
  };

  const listItems = [
    {
      title: "Last Updated",
      value: dateWithCurrentTimezone(item.lastUpdatedDateTime),
      childrens: [
        {
          title: "Name",
          slug: "last-update-name",
          value: (item?.lastUpdatedBy) || "",
        },
        {
          title: "Email address",
          slug: "last-update-email",
          value: (item?.lastUpdatedByEmail) || "",
          callback: () => {
            window.location.href = `mailto:${item.lastUpdatedByEmail}`;
          },
        },
        {
          title: "Phone",
          slug: "last-update-phone",
          value: (item?.lastUpdatedByPhoneNumber) || "",
          callback: () => {
            CallNumber.callNumber(item.lastUpdatedByPhoneNumber, true)
              .then(() => { })
              .catch(() => { });
          },
        },
      ],
    },
    {
      title: "",
      value: "",
      childrens: [
        {
          title: "Capacity Type",
          slug: "capacity-type",
          value: capitalize(item.capacityType, true),
        },
        {
          title: "Trailer Type",
          slug: "trailer-type",
          value: item?.trailerType,
        },
      ],
    },
    {
      title: "Origin",
      value: "",
      childrens: [
        {
          title: "Origin",
          slug: "origin-name",
          value:
            item &&
            `${item.origin.city}${item.origin.state ? ", " + item.origin.state : ""
            }`,
        },
        {
          title: "Origin Radius",
          slug: "origin-radius",
          value: `${item.origin.radius}mi`,
        },
        ...pickupDateType,
      ],
    },
    {
      title: "Destination",
      value: "",
      childrens: [
        {
          title:
            item && item.destinationStates && item.destinationStates.length
              ? "States"
              : "Destination",
          slug:
            item && item.destinationStates && item.destinationStates.length
              ? "destination-states"
              : "destination-details",
          value: destinationValue
        },
        ...radius,
      ],
    },
  ];

  return (
    <IonPage className="desktop-page view-manage-capacity">
      <ManageCapacityHeader
        title={item.capacityId}
        breadcrumbItems={[
          { name: "Manage Capacity", backUrl: "/app/manage-capacity" },
          { name: "View", backUrl: "#" },
        ]}
      />
      {listItems.map((item: any, index: number) => (
        <IonGrid
          className="manage-capacity-wrapper"
          key={`main_${item.title}_${index}`}
        >
          <IonRow className="manage-capacity-wrapper-row">
            <IonCol className="manage-capacity-wrapper-col">
              {item.title == "Last Updated" && (
                <h3 className="title">
                  {item.title}:<span>{item.value}</span>
                  <IonButton className="btn-edit" onClick={onEditClick}>
                    <IonImg
                      className="edit-icon"
                      src="assets/icon/Edit-icon.svg"
                    ></IonImg>
                    Edit
                  </IonButton>
                </h3>
              )}
              {index == 0 && (
                <h3 className="field-required-title">
                  *All fields are required
                </h3>
              )}
              <IonList className="manage-capcity-list">
                {item.childrens.map((children: any) => (
                  <IonItem
                    key={children.title}
                    data-test={children.slug}
                    className="manage-capacity-item"
                  >
                    <IonLabel position="floating" mode="ios">
                      {children.title}
                    </IonLabel>
                    <IonInput
                      value={children.value}
                      readonly
                      type="text"
                      className="manage-input-field"
                      onClick={children.callback ? children.callback : () => { }}
                    ></IonInput>
                  </IonItem>
                ))}
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      ))}


      <IonGrid className="view-manage-capacity-grid">
        <IonRow>
          <IonCol></IonCol>
        </IonRow>
      </IonGrid>
    </IonPage>
  );
};
export default ManageCapacityPage;
